import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'
import { Image } from '@winnin/winnin_ui.components.image'
import { Title } from '@winnin/winnin_ui.components.title'

import MobilePagesShowcaseImage from 'assets/images/png/mobile-pages-showcase.png'
import WidthWrapper from 'components/WidthWrapper'
import { useIsDesktopNotAllowedRoute, useIsMobileDevice } from 'hooks'
import { useTranslate } from 'lib/tolgee'

import { TOLGEE_KEYS } from './translate'

import './index.scss'

const DesktopNotAllowedRouteModal = () => {
  const t = useTranslate()
  const history = useHistory()

  const isMobileDevice = useIsMobileDevice()
  const isRouteNotAllowedOnDesktop = useIsDesktopNotAllowedRoute()

  const handleRedirect = () => {
    history.push('/')
  }

  if (isMobileDevice || !isRouteNotAllowedOnDesktop) {
    return null
  }

  return (
    <div className="DesktopNotAllowedRouteModal">
      <WidthWrapper className="DesktopNotAllowedRouteModal-wrapper">
        <div className="DesktopNotAllowedRouteModal-content">
          <div className="DesktopNotAllowedRouteModal-illustration">
            <Image src={MobilePagesShowcaseImage} alt={t(TOLGEE_KEYS.illustrationDescription)} />
          </div>

          <div className="DesktopNotAllowedRouteModal-body">
            <Title tag="h2" className="DesktopNotAllowedRouteModal-title">
              {t(TOLGEE_KEYS.title)}
            </Title>
            <p className="DesktopNotAllowedRouteModal-description">{t(TOLGEE_KEYS.description)}</p>
          </div>

          <div className="DesktopNotAllowedRouteModal-divider">
            <div>{t(TOLGEE_KEYS.or)}</div>
          </div>

          <div className="DesktopNotAllowedRouteModal-actions">
            <Button appearance="outline" onClick={handleRedirect}>
              {t(TOLGEE_KEYS.returnToInsights)}
            </Button>
          </div>
        </div>
      </WidthWrapper>
    </div>
  )
}

export default observer(DesktopNotAllowedRouteModal)
